import { io } from 'socket.io-client';
import { BACKEND_URL } from '@/services/apiClient';


export const getSocket = () => io(BACKEND_URL);
